(function () {
    var frost = document.querySelector('.home-nav__frost');
    var triggers = document.querySelectorAll('.home-nav__trigger');
    if (!frost || !triggers.length) return;

    var panels = frost.querySelectorAll('.home-nav__panel');
    var bar = document.querySelector('.section-header .header');
    var root = document.documentElement;
    var closeTimer = null;
    var current = null;

    // Close grace periods, by how the pointer left. Sideways off the trigger/column gets the
    // longest window (horizontal drift lost the menu far too easily); leaving vertically gets a
    // shorter but still forgiving one; CLOSE_DELAY is the fallback for everything else.
    var CLOSE_DELAY = 160;
    var CLOSE_DELAY_X = 450;   // left sideways
    var CLOSE_DELAY_Y = 320;   // left up/down out of the dropdown

    // Extra hover room around the open column, in px. The pointer counts as still "on" the menu
    // inside this band, so a small vertical overshoot below the last link doesn't dismiss it.
    var PAD_Y = 45;

    // Shop accordion: parents expand one-at-a-time on hover/focus. The sublist
    // animates its own height + opacity; trackFrost() glues the frost surface to
    // the growing content frame-by-frame so the whole thing unrolls in sync.
    var accParents = frost.querySelectorAll('.home-nav__parent[data-acc]');
    var frostTrack = null;

    // Follow the live panel height for `dur` ms with the frost's own height
    // transition disabled, so the frost matches the sublist's CSS height
    // transition exactly (no clipping gap, no pop).
    function trackFrost(dur) {
      dur = dur || 460;
      if (frostTrack) cancelAnimationFrame(frostTrack);
      frost.style.transition = 'none';
      var start = performance.now();
      (function loop(now) {
        applyFrostHeight();
        if (now - start < dur) {
          frostTrack = requestAnimationFrame(loop);
        } else {
          frostTrack = null;
          frost.style.transition = '';
          applyFrostHeight();
        }
      })(start);
    }

    // End any in-flight trackFrost and restore the stylesheet's height transition.
    // Without this, a height change that lands mid-track (e.g. close() firing while
    // the accordion-collapse track is still running) happens with transition:none
    // and SNAPS instead of animating.
    function stopFrostTrack() {
      if (frostTrack) { cancelAnimationFrame(frostTrack); frostTrack = null; }
      frost.style.transition = '';
    }

    function collapseAcc(except) {
      accParents.forEach(function (p) {
        if (p === except || !p.classList.contains('is-expanded')) return;
        p.classList.remove('is-expanded');
        var sub = p.querySelector('.home-nav__sub');
        if (sub) sub.style.height = '0px';
        var b = p.querySelector('.home-nav__parent-label');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    function expandAcc(p) {
      collapseAcc(p);
      p.classList.add('is-expanded');
      var sub = p.querySelector('.home-nav__sub');
      if (sub) sub.style.height = sub.scrollHeight + 'px';
      var b = p.querySelector('.home-nav__parent-label');
      if (b) b.setAttribute('aria-expanded', 'true');
      trackFrost();
    }

    function navHeight() { return bar ? Math.round(bar.getBoundingClientRect().height) : 72; }

    // The frost element reserves the bar row via padding-top:var(--nav-height),
    // then clips (overflow:hidden) and animates height to unroll the menu down.
    function applyFrostHeight() {
      var nav = navHeight();
      root.style.setProperty('--nav-height', nav + 'px');
      if (current) {
        var p = panelFor(current);
        var h = p ? p.scrollHeight : 0;
        frost.style.height = (nav + h) + 'px';
      } else {
        frost.style.height = nav + 'px';
      }
    }

    function panelFor(name) { return frost.querySelector('.home-nav__panel[data-panel="' + name + '"]'); }
    function triggerFor(name) {
      var found = null;
      triggers.forEach(function (t) { if (t.getAttribute('data-panel') === name) found = t; });
      return found;
    }

    function open(name) {
      var trig = triggerFor(name);
      panels.forEach(function (p) {
        var isActive = p.getAttribute('data-panel') === name;
        p.hidden = !isActive;
        if (isActive && trig) {
          var rect = trig.getBoundingClientRect();
          if (p.getAttribute('data-align') === 'right') {
            p.style.justifyContent = 'flex-end';
            p.style.paddingLeft = '0px';
            p.style.paddingRight = (window.innerWidth - rect.right) + 'px';
          } else {
            p.style.justifyContent = 'flex-start';
            p.style.paddingRight = '0px';
            p.style.paddingLeft = rect.left + 'px';
          }
        }
      });
      triggers.forEach(function (t) {
        var on = t.getAttribute('data-panel') === name;
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
      });
      current = name;
      collapseAcc(null); // always reopen the shop accordion collapsed
      stopFrostTrack();  // a stale track must not leave transition:none on open/switch
      frost.classList.add('is-open');
      applyFrostHeight();
    }

    function close() {
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); t.classList.remove('is-active'); });
      current = null;
      collapseAcc(null);
      stopFrostTrack();  // re-enable the .38s height transition so the close animates
      frost.classList.remove('is-open');
      applyFrostHeight();
    }

    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
    // `delay` is optional — guarded with a typeof check because this is also bound directly
    // as an event listener, where the first argument would be the Event object.
    function scheduleClose(delay) {
      cancelClose();
      closeTimer = setTimeout(close, typeof delay === 'number' ? delay : CLOSE_DELAY);
    }

    // Did the pointer leave this element sideways (still level with it) rather than
    // above/below it? Those horizontal exits get the longer grace period.
    function leftSideways(el, e) {
      var r = el.getBoundingClientRect();
      return e.clientY >= r.top && e.clientY <= r.bottom;
    }

    triggers.forEach(function (t) {
      var name = t.getAttribute('data-panel');
      t.addEventListener('mouseenter', function () { cancelClose(); open(name); });
      t.addEventListener('focus', function () { cancelClose(); open(name); });
      t.addEventListener('mouseleave', function (e) {
        scheduleClose(leftSideways(t, e) ? CLOSE_DELAY_X : CLOSE_DELAY_Y);
      });
      t.addEventListener('click', function (e) { e.preventDefault(); });
    });

    // Keep-open is bound to the TEXT COLUMN only (not the full-width frosted
    // surface) — so moving left/right off the links closes, while moving up/down
    // the column keeps it open. Sideways exits just get a longer grace period.
    frost.querySelectorAll('.home-nav__panel-inner').forEach(function (col) {
      col.addEventListener('mouseenter', cancelClose);
      col.addEventListener('mouseleave', function (e) {
        scheduleClose(leftSideways(col, e) ? CLOSE_DELAY_X : CLOSE_DELAY_Y);
      });
    });

    // Shop accordion interactions: hover/focus a parent expands it (one-at-a-time);
    // click/Enter on the label toggles it (keyboard + touch friendly).
    // Track the real pointer position. When a parent collapses, the items below
    // slide up under a stationary cursor and fire a spurious mouseenter with the
    // SAME coords as the last move — gate expansion on genuine movement so a
    // collapse never auto-opens a neighbour.
    var px = -1, py = -1;
    document.addEventListener('mousemove', function (e) { px = e.clientX; py = e.clientY; }, { passive: true });

    accParents.forEach(function (p) {
      var label = p.querySelector('.home-nav__parent-label');
      p.addEventListener('mouseenter', function (e) {
        if (e.clientX === px && e.clientY === py) return; // reflow artifact, pointer didn't move
        cancelClose(); expandAcc(p);
      });
      // Backstop: a real move within a collapsed parent expands it.
      p.addEventListener('mousemove', function () {
        if (!p.classList.contains('is-expanded')) { cancelClose(); expandAcc(p); }
      });
      // Leaving the whole parent group (label + its children) in ANY direction
      // collapses it; moving between the label and its own children stays inside.
      p.addEventListener('mouseleave', function () { collapseAcc(null); trackFrost(); });
      if (label) {
        label.addEventListener('focus', function () { cancelClose(); expandAcc(p); });
        label.addEventListener('click', function (e) {
          e.preventDefault();
          if (p.classList.contains('is-expanded')) { collapseAcc(null); trackFrost(); }
          else { expandAcc(p); }
        });
      }
    });

    // Vertical hover room: treat a PAD_Y band above/below the open column (within its own
    // width) as still being "on" the menu, so a small overshoot past the last link doesn't
    // dismiss it. Only takes over the timer when the pointer leaves that band VERTICALLY —
    // sideways exits keep the longer window already set by the column's own mouseleave.
    var inBand = false;
    document.addEventListener('mousemove', function (e) {
      if (!current) { inBand = false; return; }
      var p = panelFor(current);
      var col = p ? p.querySelector('.home-nav__panel-inner') : null;
      if (!col) { inBand = false; return; }
      var r = col.getBoundingClientRect();
      var nowIn = e.clientX >= r.left && e.clientX <= r.right &&
                  e.clientY >= r.top - PAD_Y && e.clientY <= r.bottom + PAD_Y;
      if (nowIn) {
        cancelClose();
      } else if (inBand && (e.clientY < r.top - PAD_Y || e.clientY > r.bottom + PAD_Y)) {
        scheduleClose(CLOSE_DELAY_Y);
      }
      inBand = nowIn;
    }, { passive: true });

    // Inside the bar, keep open only while the cursor is horizontally over the
    // active trigger word — covers the straight-down gap from trigger to column,
    // while moving sideways off the trigger still closes (just a little slower).
    if (bar) {
      bar.addEventListener('mousemove', function (e) {
        if (!current) return;
        var t = triggerFor(current);
        if (!t) return;
        var r = t.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right) { cancelClose(); }
        else { scheduleClose(CLOSE_DELAY_X); }   // sideways off the trigger = the x-axis case
      });
      // Leaving the bar DOWNWARD means the pointer is heading into/around the open panel —
      // keep the longer window there, otherwise this would immediately undo the sideways
      // grace set above. Leaving upward/out of the window stays snappy.
      bar.addEventListener('mouseleave', function (e) {
        var r = bar.getBoundingClientRect();
        scheduleClose(e.clientY >= r.bottom ? CLOSE_DELAY_X : CLOSE_DELAY_Y);
      });
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) {
      if (current && !frost.contains(e.target) && !e.target.closest('.home-nav__trigger')) close();
    });

    // Homepage: frost only when scrolled. Inner pages: always frosted/dark
    // (no hero behind the bar, so white-over-hero would be unreadable).
    function onScroll() {
      if (document.body.classList.contains('template-index')) {
        document.body.classList.toggle('home-nav-scrolled', window.scrollY > 50);
      } else {
        document.body.classList.add('home-nav-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { if (current) open(current); else applyFrostHeight(); });

    onScroll();
    applyFrostHeight();
  })();
